import { inject, Injectable } from "@angular/core";

import { SELECT_LOGGED_IN_USER } from "@features/auth/store/auth.selector";
import {
  LOAD_INTERMEDIARY,
  SET_INTERMEDIARY_LIST,
  SET_INTERMEDIARY_LIST_LENGTH,
  SET_INTERMEDIARY_LOADING,
  SET_INTERMEDIARY_PAGINATION,
} from "@features/intermediary/store/intermediary.actions";
import { Client, TClientsPaginated } from "@models/client.model";
import { SelfModel } from "@models/self.model";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action, Store } from "@ngrx/store";
import { IntermediaryService } from "@services/intermediary.service";
import {
  catchError,
  concatMap,
  filter,
  from,
  mergeMap,
  take,
  withLatestFrom,
} from "rxjs";

import { SELECT_INTERMEDIARY_PAGINATION } from "./intermediary.selectors";

@Injectable()
export class IntermediaryEffects {
  private readonly actions$ = inject(Actions);
  private readonly intermediaryService = inject(IntermediaryService);
  private readonly store = inject(Store);

  loadIntermediaryList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LOAD_INTERMEDIARY),
      concatMap((action) =>
        this.store.select(SELECT_LOGGED_IN_USER).pipe(
          filter((user): user is SelfModel => !!user),
          take(1),
          withLatestFrom(this.store.select(SELECT_INTERMEDIARY_PAGINATION)),
          mergeMap(([user, pagination]) => {
            this.store.dispatch(SET_INTERMEDIARY_LOADING({ loading: true }));
            return this.intermediaryService
              .getIntermediary$(
                user.id,
                action.searchTerm,
                action.pagination ?? pagination
              )
              .pipe(
                mergeMap(
                  // TODO: remove any from type when be is done
                  (response: Array<Client> | TClientsPaginated | any) => {
                    const actions: Action[] = [];

                    actions.push(SET_INTERMEDIARY_LOADING({ loading: false }));

                    if ("data" in response && "totalRecords" in response) {
                      const { data, ...restPagination } = response;
                      actions.push(
                        SET_INTERMEDIARY_LIST_LENGTH({
                          length: response.totalRecords,
                        }),
                        SET_INTERMEDIARY_PAGINATION({
                          pagination: restPagination,
                        }),
                        SET_INTERMEDIARY_LIST({ data })
                      );
                    } else {
                      actions.push(
                        // TODO:
                        // SET_INTERMEDIARY_LIST({ data: response.clients })
                        // remove line bellow and replace with the one above when BE is done
                        SET_INTERMEDIARY_LIST({ data: response.clients })
                      );
                    }

                    return from(actions);
                  }
                ),
                catchError(() =>
                  from([
                    SET_INTERMEDIARY_LIST({ data: [] }),
                    SET_INTERMEDIARY_LIST_LENGTH({ length: 0 }),
                    SET_INTERMEDIARY_PAGINATION({ pagination: undefined }),
                    SET_INTERMEDIARY_LOADING({ loading: false }),
                  ])
                )
              );
          })
        )
      )
    );
  });
}
